'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { SplashScreen } from '@/components/splash-screen';
import { useUser } from '@/firebase';

export default function Home() {
  const router = useRouter();
  const { user } = useUser();

  useEffect(() => {
    const destination = user ? '/dashboard' : '/home';
    const timer = setTimeout(() => {
      router.replace(destination);
    }, 4000);

    return () => clearTimeout(timer);
  }, [router, user]);

  return <SplashScreen />;
}
